import SingleSignOn from './SingleSignOn';

export default SingleSignOn;
